export default "__VITE_ASSET__Dgjov34C__"